(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initCarousel(root) {
    if (root.dataset.lpReady === 'true') return;
    root.dataset.lpReady = 'true';
    const slides = [...root.querySelectorAll('[data-lp-slide]')];
    const dots = [...root.querySelectorAll('[data-lp-dot]')];
    if (!slides.length) return;
    let index = 0;
    let timer;
    let userPaused = false;
    let popupPaused = false;
    let pointerStart = null;
    let suppressClick = false;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', String(i === index));
      });
    }
    function stop() { window.clearInterval(timer); timer = undefined; }
    function start() {
      stop();
      if (userPaused || popupPaused || slides.length < 2 || root.dataset.autoplay !== 'true' || reduceMotion.matches || (window.Shopify && window.Shopify.designMode)) return;
      timer = window.setInterval(() => {
        if (!root.isConnected) { stop(); return; }
        if (!document.hidden) show(index + 1);
      }, Math.max(5000, Number(root.dataset.interval) || 7000));
    }
    root.querySelector('[data-lp-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    root.querySelector('[data-lp-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.addEventListener('pointerdown', (event) => { suppressClick = false; if (event.pointerType === 'touch') { pointerStart = event.clientX; stop(); } });
    root.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const delta = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(delta) > 45) {
        suppressClick = true;
        show(index + (delta < 0 ? 1 : -1));
        window.setTimeout(() => { suppressClick = false; }, 300);
      }
      start();
    });
    root.addEventListener('pointercancel', () => { pointerStart = null; suppressClick = false; start(); });
    root.addEventListener('click', event => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) start(); });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { show(index - 1); event.preventDefault(); }
      if (event.key === 'ArrowRight') { show(index + 1); event.preventDefault(); }
    });
    reduceMotion.addEventListener('change', start);
    const playToggle = root.querySelector('[data-lp-toggle-play]');
    playToggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      playToggle.setAttribute('aria-pressed', String(userPaused));
      playToggle.setAttribute('aria-label', userPaused ? root.dataset.playLabel : root.dataset.pauseLabel);
      playToggle.querySelector('[data-lp-play-icon]').textContent = userPaused ? '▶' : 'Ⅱ';
      start();
    });
    root.lpPauseForPopup = () => { popupPaused = true; stop(); };
    root.lpResumeAfterPopup = () => { popupPaused = false; start(); };
    root.lpStop = stop;
    root.lpShowBlock = (block) => { const i = slides.indexOf(block); if (i >= 0) show(i); };
    show(0);
    start();
  }
  function initAll(scope = document) { scope.querySelectorAll('[data-lp-carousel]').forEach(initCarousel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-lp-carousel]').forEach((root) => root.lpStop?.()));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-lp-carousel]');
    root?.lpShowBlock?.(event.target.closest('[data-lp-slide]'));
  });
})();
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initMenu(menu) {
    if (menu.dataset.lpMenuReady) return;
    menu.dataset.lpMenuReady = 'true';
    const trigger = menu.querySelector('summary');
    let closeTimer;
    function close(focusTrigger = false) {
      if (!menu.open) return;
      window.clearTimeout(closeTimer);
      if (reducedMotion.matches) {
        menu.open = false;
        menu.classList.remove('is-closing');
      } else {
        menu.classList.add('is-closing');
        closeTimer = window.setTimeout(() => {
          menu.open = false;
          menu.classList.remove('is-closing');
        }, 180);
      }
      if (focusTrigger) trigger.focus();
    }
    trigger.addEventListener('click', (event) => {
      if (!menu.open) return;
      event.preventDefault();
      if (menu.classList.contains('is-closing')) {
        window.clearTimeout(closeTimer);
        menu.classList.remove('is-closing');
      } else close();
    });
    document.addEventListener('pointerdown', (event) => {
      if (menu.open && menu.isConnected && !menu.contains(event.target)) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open && menu.isConnected) close(true);
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches) close();
    });
  }
  function init(scope = document) { scope.querySelectorAll('[data-lp-mobile-menu]').forEach(initMenu); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* Desktop dropdowns open on hover or click, and close with a short exit animation. */
(() => {
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope = document) {
    scope.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      if (menu.dataset.lpDropdownReady) return;
      menu.dataset.lpDropdownReady = 'true';
      const details = menu.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!details || !summary) return;
      let timer;
      function close(immediate = false) {
        window.clearTimeout(timer);
        if (!details.open) return;
        if (immediate || reducedMotion.matches) {
          details.open = false;
          details.classList.remove('lp-is-closing');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          details.classList.add('lp-is-closing');
          timer = window.setTimeout(() => {
            details.open = false;
            details.classList.remove('lp-is-closing');
            summary.setAttribute('aria-expanded', 'false');
          }, 180);
        }
      }
      menu.addEventListener('pointerenter', (event) => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        window.clearTimeout(timer);
        details.classList.remove('lp-is-closing');
        document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach((other) => {
          if (other !== details) {
            other.open = false;
            other.classList.remove('lp-is-closing');
            other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          }
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
      menu.addEventListener('pointerleave', (event) => {
        if (desktop.matches && event.pointerType !== 'touch') timer = window.setTimeout(() => close(), 100);
      });
      summary.addEventListener('click', (event) => {
        if (!details.open) return;
        event.preventDefault();
        close();
      });
      document.addEventListener('pointerdown', (event) => {
        if (details.open && !menu.contains(event.target)) close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) { close(); summary.focus(); }
      });
      desktop.addEventListener('change', (event) => { if (!event.matches) close(true); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


